export default __webpack_public_path__ + "static/media/EvXJ8nb97nQ-SD.d05c8f6c.jpg";